import React from 'react';
import { Chip, Typography, Tooltip } from '@mui/material';

const LabelChip = ({ label, onDelete, sx, maxWidth }) => {
  return (
    <Chip
      label={
        <Tooltip title={label.name || label}>
          <Typography
            variant="body2"
            sx={{
              maxWidth: maxWidth ? `${maxWidth}px` : '120px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontSize: '10px',
              fontWeight: 500,
            }}
          >
            {label.name || label}
          </Typography>
        </Tooltip>
      }
      size="small"
      onDelete={onDelete}
      sx={{
        margin: '2px',
       // backgroundColor: '#E8E8E8',
        backgroundColor:'rgba(232, 243, 255, 0.65)',
        color: 'rgb(93, 94, 95)',
        padding: '4px 8px',
        gap: '5px',
        borderRadius: '5px',
        ...sx,
      }}
    />
  );
};

export default LabelChip;
